import "./scss/index.scss";
import React from "react";
import classNames from "classnames";
export function SliceLabeledIcons(_ref) {
  var fields = _ref.fields;
  return React.createElement("div", {
    className: "labeled-icons"
  }, fields && React.createElement("ul", {
    className: "labeled-icons__list container"
  }, fields.map(function (item, i) {
    return React.createElement("li", {
      key: i,
      className: classNames("labeled-icons__list-item", item.type || "")
    }, React.createElement("div", {
      className: "labeled-icons__list-img"
    }, React.createElement("img", {
      src: item.icon.url,
      alt: "labeled-icons"
    })), React.createElement("span", null, item.label));
  })));
}
SliceLabeledIcons.componentName = "labeled_icons";
export default SliceLabeledIcons;